var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M20 15.002h4c-.013.526-.228 1.027-.6 1.4-.372.372-.874.587-1.4.6H2c-.526-.013-1.028-.228-1.4-.6-.372-.373-.587-.874-.6-1.4h4c-.526-.013-1.028-.228-1.4-.6-.372-.372-.587-.874-.6-1.4v-11c.013-.526.228-1.028.6-1.4.372-.372.874-.587 1.4-.6h16c.526.013 1.028.228 1.4.6.372.372.587.874.6 1.4v11c-.002.261-.056.52-.16.76-.102.24-.252.458-.44.64-.176.195-.392.35-.634.454-.242.103-.503.153-.766.146zm-16-13v11h16v-11H4zm7.3 13.7c.161.154.37.247.593.264.222.017.443-.043.626-.17s.316-.313.377-.528c.062-.214.048-.442-.04-.647-.088-.205-.244-.373-.441-.476-.197-.103-.424-.135-.642-.09-.219.044-.415.163-.555.336-.141.172-.218.388-.218.611-.004.131.021.262.073.383.052.12.13.229.227.317z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeb);
export default __webpack_public_path__ + "static/media/icon-web.9ced3112.svg";
export { ForwardRef as ReactComponent };